var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (article) {pug_html = pug_html + "\u003Cdiv class=\"content__holder\"\u003E\u003Cdiv class=\"content__article\"\u003E\u003Carticle" + (" class=\"article\""+pug.attr("id", 'article-' + article.id, true, true)+pug.attr("data-url", article.url, true, true)+pug.attr("data-datepub", article.datePub, true, true)) + "\u003E\u003Cdiv class=\"article__date\"\u003E" + (null == (pug_interp = article.date.date) ? "" : pug_interp) + "\u003Cspan class=\"article__time\"\u003E" + (null == (pug_interp = article.date.time) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
if ((article.routesToPages !== null)) {
// iterate article.routesToPages
;(function(){
  var $$obj = article.routesToPages;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var rout = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle\"\u003E\u003Ca" + (" class=\"list__src\""+pug.attr("href", rout.routePath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = rout.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var rout = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle\"\u003E\u003Ca" + (" class=\"list__src\""+pug.attr("href", rout.routePath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = rout.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if ((article.authors && article.authors.length)) {
// iterate article.authors
;(function(){
  var $$obj = article.authors;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var author = $$obj[pug_index1];
pug_html = pug_html + "\u003Cspan class=\"article__author\"\u003E" + (null == (pug_interp = author.fullName) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var author = $$obj[pug_index1];
pug_html = pug_html + "\u003Cspan class=\"article__author\"\u003E" + (null == (pug_interp = author.fullName) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003Ch1 class=\"article__title\"\u003E" + (null == (pug_interp = article.title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003Cdiv class=\"article__media\"\u003E";
if (article.mediaCount === 0) {
pug_html = pug_html + "\u003Cdiv class=\"article__photo\"\u003E\u003Cdiv class=\"no-photo\"\u003E\u003Cimg" + (" src=\"\u002Fi\u002Ffake_lw.png\""+pug.attr("alt", article.title, true, true)+pug.attr("title", article.title, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (article.mediaCount === 1) {
if (article.videos && article.videos.length) {
// iterate article.videos
;(function(){
  var $$obj = article.videos;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var video = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"article__video\"\u003E\u003Ciframe" + (pug.attr("src", video.source, true, true)+pug.attr("name", 'vgtrk_player_' + article.id, true, true)+" allowfullscreen=\"\" frameborder=\"0\" mozallowfullscreen=\"\" webkitallowfullscreen=\"\"") + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var video = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"article__video\"\u003E\u003Ciframe" + (pug.attr("src", video.source, true, true)+pug.attr("name", 'vgtrk_player_' + article.id, true, true)+" allowfullscreen=\"\" frameborder=\"0\" mozallowfullscreen=\"\" webkitallowfullscreen=\"\"") + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
else
if (article.pictures && article.pictures.length) {
// iterate article.pictures
;(function(){
  var $$obj = article.pictures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var picture = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"article__photo vgtrk-lazy-preloader\"\u003E\u003Cimg" + (" class=\"vgtrk-lazy\""+pug.attr("data-src", picture.url.xw, true, true)+pug.attr("alt", picture.alt, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E";
if ((picture.source)) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"article__photo-author\""+pug.attr("data-author-url", picture.link, true, true)) + "\u003E\u003Cp\u003E\u003Cspan class=\"article__photo-alt\"\u003E" + (null == (pug_interp = picture.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"article__photo-auth\"\u003E" + (null == (pug_interp = picture.author) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var picture = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"article__photo vgtrk-lazy-preloader\"\u003E\u003Cimg" + (" class=\"vgtrk-lazy\""+pug.attr("data-src", picture.url.xw, true, true)+pug.attr("alt", picture.alt, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E";
if ((picture.source)) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"article__photo-author\""+pug.attr("data-author-url", picture.link, true, true)) + "\u003E\u003Cp\u003E\u003Cspan class=\"article__photo-alt\"\u003E" + (null == (pug_interp = picture.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"article__photo-auth\"\u003E" + (null == (pug_interp = picture.author) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
}
if (article.mediaCount > 1) {
pug_html = pug_html + "\u003Cdiv class=\"article__slider article__slider_top swiper-container\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E";
if (article.videos && article.videos.length) {
// iterate article.videos
;(function(){
  var $$obj = article.videos;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var video = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cdiv class=\"article__video\"\u003E\u003Ciframe" + (pug.attr("src", video.source, true, true)+pug.attr("name", 'vgtrk_player_' + article.id, true, true)+pug.attr("allowfullscreen", true, true, true)+pug.attr("frameborder", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("webkitallowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var video = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cdiv class=\"article__video\"\u003E\u003Ciframe" + (pug.attr("src", video.source, true, true)+pug.attr("name", 'vgtrk_player_' + article.id, true, true)+pug.attr("allowfullscreen", true, true, true)+pug.attr("frameborder", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("webkitallowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
if (article.pictures && article.pictures.length) {
// iterate article.pictures
;(function(){
  var $$obj = article.pictures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var picture = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cdiv class=\"article__photo\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", picture.url.xw, true, true)+pug.attr("alt", picture.alt, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E";
if ((picture.source)) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"article__photo-author\""+pug.attr("data-author-url", picture.link, true, true)) + "\u003E\u003Cp\u003E\u003Cspan class=\"article__photo-alt\"\u003E" + (null == (pug_interp = picture.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"article__photo-auth\"\u003E" + (null == (pug_interp = picture.author) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var picture = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cdiv class=\"article__photo\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", picture.url.xw, true, true)+pug.attr("alt", picture.alt, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E";
if ((picture.source)) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"article__photo-author\""+pug.attr("data-author-url", picture.link, true, true)) + "\u003E\u003Cp\u003E\u003Cspan class=\"article__photo-alt\"\u003E" + (null == (pug_interp = picture.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"article__photo-auth\"\u003E" + (null == (pug_interp = picture.author) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"article__slider_thumbs swiper-container\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E";
if (article.videos && article.videos.length) {
// iterate article.videos
;(function(){
  var $$obj = article.videos;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var video = $$obj[pug_index6];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", video.picture.url.nw, true, true)+pug.attr("alt", video.picture.alt, true, true)+pug.attr("title", video.picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var video = $$obj[pug_index6];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", video.picture.url.nw, true, true)+pug.attr("alt", video.picture.alt, true, true)+pug.attr("title", video.picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
if (article.pictures && article.pictures.length) {
// iterate article.pictures
;(function(){
  var $$obj = article.pictures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var picture = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", picture.url.nw, true, true)+pug.attr("alt", picture.title, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var picture = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide\"\u003E\u003Cimg" + (" class=\"swiper-lazy\""+pug.attr("data-src", picture.url.nw, true, true)+pug.attr("alt", picture.title, true, true)+pug.attr("title", picture.title, true, true)) + "\u003E\u003Cdiv class=\"swiper-lazy-preloader\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"article__body\"\u003E\u003Cdiv class=\"share\"\u003E\u003Cdiv class=\"ya-share2\" data-services=\"vkontakte,odnoklassniki\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"article__text\"\u003E\u003Cdiv class=\"article__anons\"\u003E" + (null == (pug_interp = article.anons) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"js-mediator-article\"\u003E" + (null == (pug_interp = article.body) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tags qwerty\"\u003E";
// iterate article.tagsData
;(function(){
  var $$obj = article.tagsData;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var tag = $$obj[pug_index8];
pug_html = pug_html + "\u003Ca" + (" class=\"tags__item\""+pug.attr("href", tag.url, true, true)) + "\u003E" + (null == (pug_interp = tag.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var tag = $$obj[pug_index8];
pug_html = pug_html + "\u003Ca" + (" class=\"tags__item\""+pug.attr("href", tag.url, true, true)) + "\u003E" + (null == (pug_interp = tag.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Cdiv class=\"slot slot--after-article\"\u003E\u003Cdiv class=\"slot__container slot__container--static\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content__slots\"\u003E\u003Cdiv class=\"slot slot--article\"\u003E\u003Cdiv class=\"slot__container slot__container--static\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slot__container slot__container--sticky\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"article" in locals_for_with?locals_for_with.article:typeof article!=="undefined"?article:undefined));;return pug_html;};
module.exports = template;